import React from "react";
import stringTemplate from "./templates/string";
import arrayTemplate from "./templates/array";
import numberTemplate from "./templates/number";
import dateTemplate from "./templates/date";
import enumTemplate from "./templates/enum";
import categoryTemplate from "./templates/category";
import switchTemplate from "./templates/switch";
import segmentTemplate from "./templates/segment";
import Box from "@mui/material/Box";
import moment from "moment-timezone";
import {addNullForEmptyField} from "../../services/helper";
import {getTimeZoneValue} from "../../api/timeZone";

export const renderForm = (data, key) => {
    switch (data.type) {
        case 'date':
            return (dateTemplate(data, key));
        case 'array':
            return (arrayTemplate(data, key));
        case 'enum':
            return (enumTemplate(data, key));
        case 'number':
            return (numberTemplate(data, key));
        case 'string':
            return (stringTemplate(data, key));
        case 'category':
            return (categoryTemplate(data, key));
        case 'segment':
            return (segmentTemplate(data, key));
        case 'switch':
            return (switchTemplate(data, key));
        default:
            return (<Box>Did not found type of component</Box>);
    }
}


export const updateInfo = (columns, data) => {
    const obj = {};
    columns.forEach((column) => {
        switch (column.type) {
            case 'date':
                let formatted = null
                if(column.momentObj){
                    formatted = moment(data.get(column.name), 'MM/DD/YYYY').tz(getTimeZoneValue(), true).hour(0).minute(0).format();
                } else if(column.validity) {
                    formatted = moment(data.get(column.name), 'MM/DD/YYYY').format('DD.MM.YYYY')
                    
                }
                obj[column.name] = formatted;
                break;
            case 'array':
                obj[column.name] = column.value;
                break;
            case 'segment':
                obj[column.name] = column.value;
                break;
            case 'category':
                obj[column.name] = column.value.id;
                break;
            case 'enum':
                obj[column.name] = data.get(column.name);
                break;
            case 'number':
                obj[column.name] = parseInt(data.get(column.name));
                break;
            case 'switch':
                obj[column.name] = column.value ? 'true' : 'false';
                break;
            default:
                obj[column.name] = data.get(column.name);
        }
    })

    addNullForEmptyField(obj);

    return obj;
}
